// extracted by mini-css-extract-plugin
export default {"card":"Card_card__64dga","cardContent":"Card_cardContent__rW7e9","cardLogo":"Card_cardLogo__AhybT","cardTitle":"Card_cardTitle__4fiUQ"};